import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { clearCart, getCartSummary, readCart, removeCartItem, updateCartItem } from "../../lib/cart";

export default function Cart({ setVisibleRight }) {
  const [items, setItems] = useState(readCart());

  useEffect(() => {
    const syncCart = () => setItems(readCart());
    window.addEventListener("storage", syncCart);
    window.addEventListener("cart-change", syncCart);
    return () => {
      window.removeEventListener("storage", syncCart);
      window.removeEventListener("cart-change", syncCart);
    };
  }, []);

  const summary = useMemo(() => getCartSummary(items), [items]);

  const handleChange = (lineId, delta) => {
    const nextItems = updateCartItem(lineId, (item) => ({
      ...item,
      quantity: Math.max(1, Number(item.quantity || 1) + delta),
    }));
    setItems(nextItems);
  };

  const handleDelete = (lineId) => {
    const nextItems = removeCartItem(lineId);
    setItems(nextItems);
  };

  return (
    <div className="flex h-full flex-col gap-6 bg-white p-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-emerald-700">আপনার কার্ট</p>
          <h2 className="brand-serif text-3xl font-bold text-slate-950">নির্বাচিত পণ্য</h2>
        </div>
        <button onClick={() => clearCart()} className="text-sm font-semibold text-slate-500 hover:text-emerald-700">
          সব মুছুন
        </button>
      </div>

      <div className="flex-1 space-y-4 overflow-y-auto pr-1">
        {items.length === 0 ? (
          <div className="rounded-lg border border-dashed border-slate-300 bg-slate-50 p-8 text-center">
            <p className="text-lg font-semibold text-slate-900">কার্ট খালি</p>
            <p className="mt-2 text-sm text-slate-500">কিছু পণ্য যোগ করলে এখানে দেখাবে।</p>
            <Link to="/all-products" onClick={() => setVisibleRight?.(false)} className="primary-button mt-5">
              এখনই কেনাকাটা করুন
            </Link>
          </div>
        ) : (
          items.map((item) => (
            <article key={item.lineId} className="flex items-center gap-4 rounded-lg border border-black/5 bg-slate-50 p-3">
              <img src={item.image} alt={item.productName} className="h-20 w-16 rounded-2xl object-cover" />
              <div className="min-w-0 flex-1">
                <Link to={`/productDetails/${item.productId}`} className="line-clamp-2 font-semibold text-slate-900">
                  {item.productName}
                </Link>
                <p className="mt-1 text-xs text-slate-500">
                  {item.long ? `লং: ${item.long}` : null} {item.body ? `বডি: ${item.body}` : null}
                </p>
                <div className="mt-2 flex items-center gap-3">
                  <span className="text-sm font-bold text-slate-900">৳{Number(item.price || 0).toFixed(0)}</span>
                  <div className="flex items-center gap-2 rounded-full bg-white px-2 py-1 shadow-sm">
                    <button onClick={() => handleChange(item.lineId, -1)} className="h-7 w-7 rounded-full bg-slate-100 text-lg leading-none">−</button>
                    <span className="min-w-6 text-center text-sm font-semibold">{item.quantity}</span>
                    <button onClick={() => handleChange(item.lineId, 1)} className="h-7 w-7 rounded-full bg-slate-100 text-lg leading-none">+</button>
                  </div>
                </div>
              </div>
              <button onClick={() => handleDelete(item.lineId)} className="text-sm font-semibold text-rose-600">মুছুন</button>
            </article>
          ))
        )}
      </div>

      <div className="rounded-lg border border-emerald-100 bg-emerald-50 p-4">
        <div className="flex items-center justify-between text-sm text-slate-700"><span>সাবটোটাল</span><span className="font-semibold">৳{summary.subtotal.toFixed(0)}</span></div>
        <div className="mt-2 flex items-center justify-between text-sm text-slate-700"><span>ডিসকাউন্ট</span><span className="font-semibold">৳{summary.discountTotal.toFixed(0)}</span></div>
        <div className="mt-4 flex items-center justify-between border-t border-emerald-200 pt-4 text-base font-bold text-slate-950"><span>মোট</span><span>৳{summary.total.toFixed(0)}</span></div>
        <Link to="/viewCart" onClick={() => setVisibleRight?.(false)} className="primary-button mt-4 w-full">
          চেকআউটে যান
        </Link>
      </div>
    </div>
  );
}
